import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useRequestGroupCreateMutation } from '../../api/requestApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import { TextEditor } from '../../components/TextEditor/TextEditor';
import BroadcastToggleField from '../../components/BroadcastToggleField/BroadcastToggleField';
import ChannelsField from '../../components/ChannelsField/ChannelsField';
import buttons from '../../styles/shared/buttons.module.css';

export default function GroupRequestCreatePage() {
  const navigate = useNavigate();
  const showToast = useToast();

  const [requestGroupCreate, { isLoading: isSubmitting }] = useRequestGroupCreateMutation();

  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: { name: '', tileImageUrl: '', terms: '', channels: ['email'], broadcast: true },
  });
  const broadcast = watch('broadcast');

  const onSubmit = async (data) => {
    try {
      await requestGroupCreate({
        name: data.name.trim(),
        tile_image_url: data.tileImageUrl.trim() || undefined,
        terms: data.terms.trim() || undefined,
        channels: data.channels,
        broadcast: data.broadcast,
      }).unwrap();
      showToast('success', 'Groups', 'Request sent to admin for approval.');
      navigate('/manager/groups');
    } catch (err) {
      showToast('error', 'Groups', errMsg(err, 'Could not submit request.'));
    }
  };

  return (
    <EntityFormPage title="Request new group" backTo="/manager/groups">
      <p className="textMuted mb-3">
        This will be sent to an admin for approval before the group is created.
      </p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="name"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Name</label>
              <InputText id={field.name} className="w-full mb-3" placeholder="Pizza Station" {...field} />
            </div>
          )}
        />

        <Controller
          name="tileImageUrl"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Tile image URL</label>
              <InputText
                id={field.name}
                className="w-full mb-3"
                placeholder="https://…/pizza.jpg (optional)"
                {...field}
              />
            </div>
          )}
        />

        <Controller
          name="terms"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Terms &amp; conditions</label>
              <TextEditor value={field.value} onTextChange={(e) => field.onChange(e.htmlValue ?? '')} />
            </div>
          )}
        />

        <ChannelsField control={control} broadcast={broadcast} />

        <BroadcastToggleField control={control} setValue={setValue} />

        <Button type="submit" label="Submit request" className={buttons.saveBtn} loading={isSubmitting} />
      </form>
    </EntityFormPage>
  );
}
